import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../routes/route-path";
import { BrandingData } from "admin-portal/settings/branding";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { UserForgetPassword } from "api/user";
import LoadingComponent from "common/components/loader";

const ForgetPasswordComponent: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: Yup.object({
      //email: Yup.string().email("Invalid email address").required("Email is required"),
      username: Yup.string().required("Username is required"),
    }),
    onSubmit: async (values) => {
      // Handle form submission logic here (e.g., send reset link)

      try {
        setError("");
        setSuccess("");
        setLoading(true);
        const res = await UserForgetPassword({
          username: values.username,
        });

        if (!(res?.status?.isError ?? false) && (res?.data?.status ?? false)) {
          setSuccess("success");
        } else {
          setError("error");
        }
        setLoading(false);
      } catch (error) {
        setError("error");
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div className="mt-8 text-center">
        <h4 className="mb-2 text-custom-500 dark:text-custom-500">Forgot Password?</h4>
        <p className="mb-8 text-slate-500 dark:text-zink-200">Reset your {BrandingData.siteName} password</p>
      </div>

      <div className="px-4 py-3 mb-6 text-sm text-yellow-500 border border-transparent rounded-md bg-yellow-50 dark:bg-yellow-400/20">
        Provide your username, and instructions will be sent to your email
      </div>

      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <div>
          <label htmlFor="usernameInput" className="inline-block mb-2 text-base font-medium">
            Username
          </label>
          <input
            type="text"
            className={`form-input  focus:outline-none 
                        focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 
                        disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 
                        disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 
                        placeholder:text-slate-400 dark:placeholder:text-zink-200 
                        ${
                          formik.touched.username && formik.errors.username
                            ? "border-red-500"
                            : "border-slate-200 dark:border-zink-500"
                        }`}
            placeholder="Username"
            id="usernameInput"
            name="username"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.username}
          />
          {formik.touched.username && formik.errors.username ? (
            <div className="text-sm text-red-500">{formik.errors.username}</div>
          ) : null}
        </div>
        <div className="mt-8">
          <button
            type="submit"
            className="w-full text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Send Reset Link
          </button>
        </div>
        <div className="mt-4 text-center">
          <p className="mb-0">
            Wait, I remember my password...{" "}
            <Link to={RoutePath.Admin_Login_page} className="underline fw-medium text-custom-500">
              {" "}
              Click here{" "}
            </Link>{" "}
          </p>
        </div>
      </form>

      {success && (
        <div
          className="px-4 py-3 mt-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
          id="successAlert"
        >
          <b>Success! </b> An email has been sent to your registered email address. Please check your inbox and follow
          the provided link to complete the process.
        </div>
      )}
      {error && (
        <div
          className="px-4 py-3 mt-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
          id="successAlert"
        >
          Oops! Something went wrong while attempting to send the password reset email. Please try again later or
          contact support for assistance.
        </div>
      )}
      {loading && <LoadingComponent></LoadingComponent>}
    </>
  );
};
export default ForgetPasswordComponent;
